import '../../../App.css';
import { Link } from 'react-router-dom';

import logoUtiNeo from '../../../img/logoUtiNeo.png';

const Footer = () => {
    return (
        // < !--Footer Start-- >
        <section id="footer">
            <footer>
                <div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s">
                    <div className="container py-5">
                        <div className="row g-5">
                            <div className="col-md-6 col-lg-6 col-xl-4">
                                <div style={{ marginLeft: 80 }}>
                                    <img src={logoUtiNeo} alt="Logo" style={{ width: 70 }} />
                                </div>
                                <div className="footer-item d-flex flex-column">
                                    <h4 className="text-white mb-4">UTI Neonatal<br />Unimed
                                        Sudoeste Minas
                                    </h4>
                                    <div className="d-flex align-items-center">
                                        <i className="fas fa-share fa-2x text-white me-2"></i>
                                        <a className="d-flex btn-square btn btn-primary text-white rounded-circle mx-1" href=""><i
                                            className="fab fa-facebook-f"></i></a>
                                        <a className="d-flex btn-square btn btn-primary text-white rounded-circle mx-1" href=""><i
                                            className="fab fa-twitter"></i></a>
                                        <a className="d-flex btn-square btn btn-primary text-white rounded-circle mx-1" href=""><i
                                            className="fab fa-instagram"></i></a>
                                        <a className="d-flex btn-square btn btn-primary text-white rounded-circle mx-1" href=""><i
                                            className="fab fa-linkedin-in"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4">
                                <div className="footer-item d-flex flex-column">
                                    <h4 className="mb-4 text-white">Links</h4>
                                    <Link to="/"><i className="fas fa-angle-right me-2"></i> Sobre</Link>
                                    <Link to="/Equipe"><i className="fas fa-angle-right me-2"></i> Equipe</Link>
                                    <Link to="/Treinamentos"><i className="fas fa-angle-right me-2"></i> Treinamento</Link>
                                    <Link to="/"><i className="fas fa-angle-right me-2"></i> Contato</Link>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4">
                                <div className="footer-item d-flex flex-column">
                                    <h4 className="mb-4 text-white">Informações</h4>
                                    <a href=""><i className="fa fa-map-marker-alt me-2"></i> Avenida Dr. Breno Soares Maia, 236 <br />
                                        Belo Horizonte - Passos/MG</a>
                                    <a href=""><i className="fas fa-envelope me-2"></i> email@unimed.com</a>
                                    <a href=""><i className="fas fa-phone me-2"></i> (35) 3529-2600</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!--Footer End-- >         */}
                </div>
            </footer>
        </section>
    );
}

export default Footer;